import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'activity-heartbeat', 'ActivityHeartbeat', [["path",{"d":"M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5","key":"svg-0"}]]);